import { useRouter } from 'next/router';
import { Heading, Page, Text } from '@zillow/constellation-10';
import { TermsHtml } from '@zg-rentals/id-verification';
import { GetTermSetDocument, TermId, TermSetId } from '../../graphql/queries';
import { useQuery } from '@apollo/client';

const experianUse = 'Experian-Terms-of-Use';
const experianPrivacy = 'Experian-Privacy-Policy';
const experianNotice = 'Experian-Notice-to-Users';
const experianReminder = 'Experian-Terms-Reminder';
const cicUse = 'CIC-Terms-of-Use';

// /terms/[termId] is a legacy route - used only in native webviews
export default function TermsPage() {
  const router = useRouter();
  const { termId } = router.query as { termId: string };

  const {
    data: termSetData,
    loading: termSetDataLoading,
    error: termSetDataLoadingError,
  } = useQuery(GetTermSetDocument, {
    variables: { termSetId: TermSetId.renterScreening },
  });

  const cicTermVersion = termSetData?.termSet?.terms?.find((term) => term?.id === TermId.CIC_TAC)?.currentVersion || 2;

  let html = '';
  if (termId === experianUse) {
    html = TermsHtml.ExperianTac;
  } else if (termId === experianPrivacy) {
    html = TermsHtml.ExperianPp;
  } else if (termId === experianNotice) {
    html = TermsHtml.NoticeToUsers;
  } else if (termId === experianReminder) {
    html = TermsHtml.ExperianTermsReminder;
  } else if (termId === cicUse) {
    html = termSetDataLoadingError || cicTermVersion === 3 ? TermsHtml.CicTacNew : TermsHtml.CicTac;
  }

  function getTitleForTerm() {
    switch (termId) {
      case experianUse:
        return 'Experian Terms and Conditions';
      case experianPrivacy:
        return 'Experian Privacy Policy';
      case experianNotice:
        return 'Experian Notice to Users';
      case experianReminder:
        return 'Terms and Policies';
      case cicUse:
        return 'CIC Terms and Conditions';
      default:
        return '';
    }
  }
  return (
    <Page.Root css={{ backgroundColor: 'bg.neutral' }}>
      <Page.Header>
        <Heading level={1}>{getTitleForTerm()}</Heading>
      </Page.Header>
      <Page.Content>
        {termSetDataLoading && termId === cicUse ? null : (
          <Text asChild>
            <div dangerouslySetInnerHTML={{ __html: html }} />
          </Text>
        )}
      </Page.Content>
    </Page.Root>
  );
}
